import { Link } from "@tanstack/react-router";
import { ArrowRight, Check, WalletCards } from "lucide-react";
import { cn } from "@/lib/utils";

const BALANCE_RULES = [
	"No subscription or seat fee",
	"Top up from $1 to $1,000",
	"Balance deducts as jobs run",
	"Pre-configured providers and storage included",
];

export function PricingTable({ className }: { className?: string }) {
	return (
		<div className={cn("px-6 sm:px-10", className)}>
			<div className="flex items-center justify-between gap-3">
				<div className="flex size-10 items-center justify-center rounded-lg border border-border bg-card">
					<WalletCards className="size-5 text-[#6B3FF2]" />
				</div>
				<span className="inline-flex rounded-full border border-[#6B3FF2]/30 bg-[#6B3FF2]/10 px-2 py-0.5 text-[11px] font-medium text-[#6B3FF2]">
					Usage-based
				</span>
			</div>

			<h3 className="mt-5 text-2xl font-semibold text-foreground">
				Workspace balance
			</h3>
			<p className="mt-3 max-w-md text-sm leading-relaxed text-muted-foreground">
				Add balance through Stripe Checkout. Each generation job deducts from
				your workspace as it runs &mdash; no tiers, no plans, no commit.
			</p>

			<ul className="mt-6 space-y-2.5">
				{BALANCE_RULES.map((feature) => (
					<li
						key={feature}
						className="flex items-start gap-3 text-sm text-foreground"
					>
						<Check className="mt-0.5 size-4 shrink-0 text-[#6B3FF2]" />
						<span>{feature}</span>
					</li>
				))}
			</ul>

			<div className="mt-8">
				<Link
					to="/onboard"
					className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-transparent bg-[#6B3FF2] px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#5A33D4]"
				>
					Top up to start
					<ArrowRight className="size-4" />
				</Link>
			</div>
		</div>
	);
}
